var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDigitalGovernance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconGovernancaDigital 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6364 5.71028C16.9847 5.49905 14.5122 4.28915 12.7184 2.32501C12.3802 1.9331 11.7884 1.88951 11.3965 2.22766C11.3617 2.25768 11.3292 2.29022 11.2991 2.32501C9.50526 4.28915 7.03273 5.49905 4.38113 5.71028C3.8884 5.75645 3.51291 6.1719 3.51663 6.66678V9.08001C3.51663 14.3266 6.85338 19.1258 11.4864 22.0956C11.8046 22.3001 12.2129 22.3001 12.5311 22.0956C17.1641 19.1251 20.5009 14.3266 20.5009 9.08001V6.66678C20.5046 6.1719 20.1291 5.75645 19.6364 5.71028ZM18.8759 9.08001C18.8759 13.255 16.3886 17.4668 12.2224 20.3491L12.0088 20.4969L11.7956 20.3491C7.62913 17.4666 5.14138 13.2538 5.14138 9.08001V7.26728L5.45738 7.21728C7.81163 6.84501 10.0029 5.78368 11.7546 4.16727L12.0086 3.93327L12.2629 4.16727C14.0145 5.78368 16.2057 6.84501 18.5599 7.21728L18.8759 7.26728V9.08001Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0088 4.94702C10.2731 6.4651 8.15962 7.48639 5.8916 7.903V9.08001C5.8916 12.9368 8.17332 16.8458 12.0091 19.5826C15.8443 16.8463 18.1261 12.9371 18.1261 9.08001V7.903C15.858 7.48639 13.7446 6.4651 12.0088 4.94702ZM11.3669 14.7083L8.83882 12.1801L9.69786 11.3211L11.3669 12.99L14.7849 9.57202L15.6438 10.4313L11.3669 14.7083Z",
    fill: "#E9E9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalGovernance);
export default __webpack_public_path__ + "static/media/icon-digital-governance.0118cf9ac0d97df5364ef849c15d5c0d.svg";
export { ForwardRef as ReactComponent };